/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
var __webpack_exports__ = {};

;// CONCATENATED MODULE: ./src/js/bundles/sections/hrg-filter.js
/* eslint-disable prettier/prettier */
var herbFilter = function herbFilter() {
  // Precompute whether articles exist for each letter
  var letterHasArticles = {};
  var hrgFilterSection = document.getElementById('hrg-filter-section');
  var herbs = document.querySelectorAll('.herb-item');
  var allLetters = 'abcdefghijklmnopqrstuvwxyz'.split('');

  // Check if herbs and letters exist before proceeding
  if (herbs.length === 0) {
    return;
  }
  var letters = document.querySelectorAll('[data-letter]');
  if (letters.length === 0) {
    return;
  }

  // Initialize the letterHasArticles mapping
  allLetters.forEach(function (letter) {
    letterHasArticles[letter] = Array.from(herbs).some(function (herb) {
      return herb.getAttribute('data-first-letter') === letter;
    });
  });

  // Set default filter to 'A' on page load if 'A' has articles
  filterByLetter('a', false);

  // Add event listeners for each letter
  letters.forEach(function (letter) {
    var letterText = letter.getAttribute('data-letter').toLowerCase();
    if (!letterText) {
      return;
    }
    if (letterText !== 'all' && letterHasArticles[letterText]) {
      letter.addEventListener('click', function () {
        return filterByLetter(letterText);
      });
    }
  });

  // Add event listener for the "Show All" option
  var showAllLetters = document.querySelectorAll('[data-letter="All"]');
  if (showAllLetters.length == 0) {
    return;
  }
  if (showAllLetters.length > 0) {
    showAllLetters.forEach(function (showAllLetter) {
      showAllLetter.addEventListener('click', function () {
        return filterByLetter('all');
      });
    });
  }
  function filterByLetter(selectedLetter) {
    var scrollToSection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var selectedLetterElement = document.querySelector('.selected-letter');
    if (!selectedLetterElement) {
      return;
    }
    selectedLetterElement.innerText = selectedLetter.toUpperCase();
    if (herbs.length === 0) {
      return;
    }
    herbs.forEach(function (herb) {
      var herbFirstLetter = herb.getAttribute('data-first-letter');
      if (!herbFirstLetter) {
        return;
      }

      // Show all herbs if 'Show All' is clicked, otherwise filter by the selected letter
      if (selectedLetter === 'all' || herbFirstLetter === selectedLetter) {
        herb.classList.remove('hidden'); // Show matching herbs
        herb.classList.add('block');
      } else {
        herb.classList.remove('block'); // Remove display block
        herb.classList.add('hidden');
      }
    });
    letters.forEach(function (letter) {
      var letterText = letter.getAttribute('data-letter').toLowerCase();
      var hasArticles = letterHasArticles[letterText];
      if (!letterText) {
        return;
      }
      if (letterText === selectedLetter) {
        letter.classList.remove('text-lime-950', 'underline');
        letter.classList.add('text-beige-950');
      } else if (!hasArticles) {
        letter.classList.remove('text-beige-950', 'underline', 'text-lime-950');
        letter.classList.add('text-gray-500', 'no-underline');
        letter.style.cursor = 'default'; // Disable cursor for letters with no articles
      } else {
        letter.classList.remove('text-beige-950', 'no-underline', 'text-gray-500');
        letter.classList.add('underline', 'text-lime-950');
        letter.style.cursor = 'pointer'; // Enable pointer cursor for clickable letters
      }

      // Handle "Show All" separately
      if (letterText === 'all') {
        letter.style.cursor = 'pointer';
        if (selectedLetter === 'all') {
          letter.classList.remove('text-lime-950', 'underline');
          letter.classList.add('text-beige-950');
        } else {
          letter.classList.remove('text-gray-500', 'no-underline', 'text-beige-950');
          letter.classList.add('text-lime-950', 'underline');
        }
      }
    });
    if (scrollToSection && hrgFilterSection) hrgFilterSection.scrollIntoView({
      behavior: 'smooth'
    });
  }
};
;// CONCATENATED MODULE: ./src/js/bundles/sections/hrg-search.js
var herbSearch = function herbSearch() {
  var searchInput = document.querySelector('.search__box');
  var searchResultsContainer = document.querySelector('.search__results');
  var overlay = document.querySelector('.background-overlay');
  var searchContainer = document.querySelector('.search__container');
  var searchStatus = document.querySelector('#ingredient-search-status');
  if (!searchInput || !searchResultsContainer || !overlay || !searchContainer || !searchStatus) {
    return;
  }
  var translations = window.hrgSearchI18n || {};
  var searchResultsDisplayed = false;
  var activeIndex = -1;
  var currentOptions = [];
  var announceStatus = function announceStatus(message) {
    searchStatus.textContent = '';
    window.requestAnimationFrame(function () {
      searchStatus.textContent = message;
    });
  };
  var getMatches = function getMatches(query) {
    var normalizedQuery = query.trim().replace(/\s+/g, ' ').toLowerCase();
    if (normalizedQuery.length <= 1) return [];
    return window.herbs.filter(function (herb) {
      return normalizedQuery && herb.title.toLowerCase().includes(normalizedQuery);
    });
  };
  var updateActiveDescendant = function updateActiveDescendant() {
    if (activeIndex >= 0 && activeIndex < currentOptions.length) {
      searchInput.setAttribute('aria-activedescendant', "ingredient-result-".concat(activeIndex));
    } else {
      searchInput.setAttribute('aria-activedescendant', '');
    }
  };
  var clearActiveOption = function clearActiveOption() {
    currentOptions.forEach(function (option) {
      option.style.backgroundColor = '';
      option.setAttribute('aria-selected', 'false');
    });
  };
  var setActiveOption = function setActiveOption(index) {
    clearActiveOption();
    activeIndex = index;
    if (activeIndex >= 0 && activeIndex < currentOptions.length) {
      var option = currentOptions[activeIndex];
      option.style.backgroundColor = '#EAEBE5';
      option.setAttribute('aria-selected', 'true');
      option.scrollIntoView({
        block: 'nearest'
      });
    }
    updateActiveDescendant();
  };
  var selectOption = function selectOption(option) {
    if (option && option.href) {
      window.location.href = option.href;
    }
  };
  searchInput.addEventListener('input', function () {
    var query = this.value.toLowerCase();
    handleSearch(query);
  });
  searchInput.addEventListener('focus', function () {
    var query = this.value.toLowerCase();
    if (query.length > 1 && searchResultsDisplayed) {
      showSearchResults();
    } else if (query.length > 1) {
      handleSearch(query);
    }
  });
  searchInput.addEventListener('blur', function () {
    setTimeout(function () {
      if (!searchResultsContainer.contains(document.activeElement)) {
        closeSearch();
      }
    }, 150);
  });
  searchInput.addEventListener('keydown', function (event) {
    var key = event.key;
    if (key === 'Escape') {
      event.preventDefault();
      closeSearch();
      return;
    }
    var isOpen = searchResultsDisplayed && currentOptions.length > 0;
    if (key === 'ArrowDown') {
      event.preventDefault();
      if (!isOpen) return;
      if (activeIndex < currentOptions.length - 1) {
        setActiveOption(activeIndex + 1);
      }
      return;
    }
    if (key === 'ArrowUp') {
      event.preventDefault();
      if (!isOpen) return;
      if (activeIndex > 0) {
        setActiveOption(activeIndex - 1);
      } else {
        setActiveOption(-1);
      }
      return;
    }
    if (key === 'Home' && isOpen) {
      event.preventDefault();
      setActiveOption(0);
      return;
    }
    if (key === 'End' && isOpen) {
      event.preventDefault();
      setActiveOption(currentOptions.length - 1);
      return;
    }
    if (key === 'Enter') {
      event.preventDefault();
      if (isOpen && activeIndex >= 0) {
        selectOption(currentOptions[activeIndex]);
      }
    }
  });
  document.addEventListener('click', function (e) {
    if (!searchInput.contains(e.target) && !searchResultsContainer.contains(e.target)) {
      closeSearch();
    }
  });
  function handleSearch(query) {
    searchResultsContainer.innerHTML = '';
    activeIndex = -1;
    currentOptions = [];
    updateActiveDescendant();
    if (query.length <= 1) {
      closeSearch();
      announceStatus('');
      return;
    }
    var normalizedQuery = query.trim().replace(/\s+/g, ' ').toLowerCase();
    if (normalizedQuery.length <= 1) {
      closeSearch();
      announceStatus('');
      return;
    }
    var filteredHerbs = getMatches(query);
    if (filteredHerbs.length > 0) {
      filteredHerbs.forEach(function (herb, index) {
        var herbElement = document.createElement('a');
        herbElement.href = herb.url;
        herbElement.classList.add('block', 'cursor-pointer', 'px-2', 'py-1', 'rounded');
        herbElement.textContent = herb.title;
        herbElement.setAttribute('role', 'option');
        herbElement.setAttribute('id', "ingredient-result-".concat(index));
        herbElement.setAttribute('aria-selected', 'false');
        herbElement.setAttribute('tabindex', '-1');
        herbElement.addEventListener('click', function (e) {
          e.preventDefault();
          selectOption(herbElement);
        });
        searchResultsContainer.appendChild(herbElement);
      });
      currentOptions = Array.from(searchResultsContainer.querySelectorAll('[role="option"]'));
      showSearchResults();
      searchInput.setAttribute('aria-expanded', 'true');
      var template = filteredHerbs.length === 1 ? translations.resultsAvailableOne : translations.resultsAvailableOther;
      announceStatus(template.replace('{{ count }}', filteredHerbs.length));
      searchResultsDisplayed = true;
    } else {
      closeSearch();
      announceStatus(translations.noIngredientsFound);
    }
  }
  function showSearchResults() {
    searchResultsContainer.classList.remove('hidden');
    searchResultsContainer.classList.add('flex', 'flex-col', 'gap-2');
    searchInput.classList.remove('rounded-3xl');
    searchInput.classList.add('rounded-t-3xl');
    searchInput.setAttribute('aria-expanded', 'true');
    overlay.classList.remove('hidden');
    searchContainer.classList.add('z-50');
  }
  function closeSearch() {
    searchResultsContainer.classList.add('hidden');
    searchResultsContainer.classList.remove('flex', 'flex-col', 'gap-2');
    searchInput.classList.remove('rounded-t-3xl');
    searchInput.classList.add('rounded-3xl');
    searchInput.setAttribute('aria-expanded', 'false');
    searchInput.setAttribute('aria-activedescendant', '');
    overlay.classList.add('hidden');
    searchContainer.classList.remove('z-50');
    searchResultsDisplayed = false;
    activeIndex = -1;
    currentOptions = [];
  }
};
;// CONCATENATED MODULE: ./src/js/bundles/templates/page.herbguide.js


herbSearch();
herbFilter();
/******/ })()
;